import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { UserBalanceDisplay } from "./balance-display";
import { UserBalanceDisplayProps } from "./balance-display/types";

export default observer(function HeaderUserBalanceDisplay(
	props: UserBalanceDisplayProps
) {
	const rootStore = useRootAppStore();

	if (
		rootStore.userAuthStore.userAccounts == null ||
		rootStore.userAuthStore.userAccounts.length == 0
	) {
		return null;
	}

	return <UserBalanceDisplay isInMenu={props.isInMenu} />;
});
